import clsx from 'clsx';
import { Button } from '../ui/Button';
import { ActionDotsBlack } from '../../icons/actionDotsBlack';
import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/Popover';
import { ToolIcon } from '../../icons/toolsIcon';
import { useNavigate } from 'react-router';
import { Dialog, DialogContent, DialogTrigger } from '../ui/Modal';
import { ConfirmationDialog } from '../ui';
import { AddDriverDashboardModal } from './addDriverDashboardModal';
import { ClockIcon } from '../../icons';
import { mapStepToMessage, mapStepToText } from '../../utils/helper';

const ActionButton = ({
  title,
  content,
  className,
  openModal,
  setOpenModal,
  handleOkClick,
}) => {
  return (
    <Dialog open={openModal} onOpenChange={(open) => setOpenModal(open)}>
      <DialogTrigger className={clsx('body-text w-full', className)}>
        {title}
      </DialogTrigger>
      <DialogContent>
        <ConfirmationDialog
          message={content}
          handleOkClick={handleOkClick}
          handleCancelClick={() => setOpenModal(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export const SliderCar = ({
  carInfo,
  active,
  driversList = [],
  handleClickAction,
  hasOnlyDriversRole,
}) => {
  const [driversModal, setDriversModal] = useState(false);
  const navigate = useNavigate();

  const { cncode, state } = carInfo;
  const { step, substatus, message } = state || {};

  const Driver = ({ driver }) => {
    const [openPopover, setOpenPopover] = useState(false);
    const [openDialogAssign, setOpenDialogAssign] = useState(false);
    const [openDialogPrimary, setOpenDialogPrimary] = useState(false);
    const [openDialogDeletion, setOpenDialogDeletion] = useState(false);

    return (
      <div className="w-full gap-4 flex justify-between">
        {/* <div className="xl:hidden 2xl:block rounded-full w-10 h-10 bg-[#6A6A6A]"/> */}
        <div>
          <h6>
            {driver.firstName} {driver.lastName}
          </h6>
          <p className="text-disclaimer">
            {driver.isPrimary ? 'Κύριος οδηγός' : 'Οδηγός'}
          </p>
        </div>
        <Popover
          open={openPopover}
          onOpenChange={(open) => {
            setOpenPopover(open);
          }}
        >
          <PopoverTrigger className="mb-4">
            <ActionDotsBlack
              className={
                openPopover
                  ? 'bg-black stroke-white rounded-full'
                  : 'stroke-black cursor-pointer'
              }
            />
          </PopoverTrigger>
          <PopoverContent
            style={{ padding: 0 }}
            className={'text-body rounded-[8px] flex flex-col items-center'}
          >
            <AddDriverDashboardModal
              mode={'edit'}
              driversDetails={driver}
              plateno={carInfo.plateno}
            />
            <div>
              <ActionButton
                className={'p-4 cursor-pointer'}
                title="Αφαίρεση"
                content={
                  <div className="flex flex-col gap-6">
                    <h3 className="text-center">Αφαίρεση Οδηγού</h3>
                    <div className="text-body">
                      Είσαι σίγουρος ότι θέλεις να αφαιρέσεις τον/την
                      <span className="font-[700]">
                        {' '}
                        {driver.firstName} {driver.lastName}
                      </span>
                    </div>
                  </div>
                }
                openModal={openDialogAssign}
                setOpenModal={setOpenDialogAssign}
                handleOkClick={() => {
                  handleClickAction('unAssignDriver', driver.id);
                  setOpenDialogAssign(false);
                }}
              />
            </div>
            {!driver.isPrimary && (
              <div>
                <ActionButton
                  className={'p-4 cursor-pointer'}
                  title="Ορισμός ως κύριος οδηγός"
                  content={
                    <div className="flex flex-col gap-6">
                      <h3 className="text-center">Ορισμός ως κύριος οδηγός</h3>
                      <div className="text-body">
                        Είσαι σίγουρος ότι θέλεις να ορίσεις τον/την{' '}
                        <b>
                          
                          {driver.firstName} {driver.lastName}{' '}
                        </b>
                        ως κύριο οδηγό;
                      </div>
                    </div>
                  }
                  openModal={openDialogPrimary}
                  setOpenModal={setOpenDialogPrimary}
                  handleOkClick={() => {
                    handleClickAction('setPrimaryDriver', driver.id);
                    setOpenDialogPrimary(false);
                  }}
                />
              </div>
            )}
              <ActionButton
                className={
                  'p-4 bg-[#F5F5F7] text-[#D4002A] cursor-pointer rounded-b-[8px] w-full'
                }
                title="Διαγραφή"
                content={
                  <div className="flex flex-col gap-6 text-center">
                    <h3 className="text-center">Διαγραφή οδηγού</h3>
                    <div className="text-body text-center">
                      Είσαι σίγουρος ότι θέλεις να διαγράψεις οριστικά τον/την{' '}
                      <b>
                        {' '}
                        {driver.firstName} {driver.lastName}{' '}
                      </b>{' '}
                      από τη συνολική λίστα οδηγών;
                    </div>
                    <div className="text-body">
                      Αυτή η ενέργεια δεν μπορεί να αναιρεθεί. Για να προστεθεί
                      ξανά ως οδηγός, θα πρέπει να καταχωρίσεις εκ νέου όλα τα
                      στοιχεία.
                    </div>
                  </div>
                }
                openModal={openDialogDeletion}
                setOpenModal={setOpenDialogDeletion}
                handleOkClick={() => {
                  handleClickAction('deleteDriver', driver.id);
                  setOpenDialogPrimary(false);
                }}
              />
          </PopoverContent>
        </Popover>
      </div>
    );
  };

  return (
    <div
      className={clsx(
        'flex flex-col justify-center items-center mt-8 lg:relative w-full',
        active && !cncode && !hasOnlyDriversRole && 'max-lg:mb-16'
      )}
    >
      <div
        className={clsx(
          'w-full lg:w-[550px] 2xl:w-[750px]',
          !active && 'opacity-20'
        )}
        title={carInfo.carTitle}
      >
        <img
          alt={carInfo.carTitle}
          src={`https://cdn.imagin.studio/getImage?customer=avis-gr&&make=${
            carInfo.MakeName ?? carInfo.carTitle?.split(' ')[0]
          }&modelFamily=${
            carInfo.ModelName === carInfo.carTitle?.split(' ')[0]
              ? carInfo.carTitle?.split(' ')[1]
              : carInfo.ModelName
          }&modelVariant=${carInfo.ModelName}&modelYear=${
            carInfo.ModelYear
          }&powerTrain=hybrid&trim=eu&zoomType=fullScreen&width=800&angle=28`}
        />
      </div>
      {active && !cncode && !hasOnlyDriversRole && (
        <>
          <div className="lg:absolute right-0 -top-5 lg:bg-white lg:bg-opacity-60 flex flex-col gap-4 px-4 lg:p-4 rounded-[10px] max-lg:w-full xl:w-[210px] 2xl:w-[288px]">
            <div className="max-lg:hidden flex w-full justify-between">
              <h3>Οδηγοί</h3>
              <AddDriverDashboardModal plateno={carInfo.plateno} />
            </div>
            <div className="max-lg:hidden flex flex-col xl:max-h-[65px] 2xl:max-h-[120px] overflow-y-auto scrollbar">
              {driversList.length > 0 ? (
                driversList.map((driver, index) => (
                  <Driver driver={driver} key={index} />
                ))
              ) : (
                <div className="flex flex-col gap-1">
                  <p className="text-body">Δεν υπάρχουν καταχωρίσεις.</p>
                  <h6 className="text-[#6A6A6A]">
                    Πρόσθεσε οδηγούς για να εμφανιστούν στη λίστα.
                  </h6>
                </div>
              )}
            </div>
            <div className="max-lg:hidden h-[1px] w-full bg-[#A5A5A5]" />
            <Button
              className={
                'text-secondary-button bg-white border border-[#A5A5A5] w-full py-3 rounded-[6px] flex gap-1.5 items-center justify-center'
              }
              onClick={() => {
                navigate('/service-booking');
              }}
            >
              <ToolIcon />
              Ραντεβού Service
            </Button>
          </div>
          <Dialog
            open={driversModal}
            onOpenChange={(open) => setDriversModal(open)}
          >
            <div
              className="lg:hidden w-full bg-white rounded-t-[12px] left-0"
              style={{
                boxShadow: '0px -8px 10px 0px #0000000D',
                position: 'absolute',
                bottom: '0px',
              }}
            >
              <div className="w-full flex justify-center mt-2">
                <DialogTrigger>
                  <div className="w-[60px] h-[2px] rounded-full bg-[#E2E2E2]" />
                </DialogTrigger>
              </div>
              <div className="w-full flex justify-between p-4">
                <h4 className="text-start">Οδηγοί</h4>
                <AddDriverDashboardModal plateno={carInfo.plateno} />
              </div>
            </div>
            <DialogContent
              blurred={false}
              className="p-3 h-[calc(100%_-_76px)]"
            >
              <div
                typeof="button"
                className="w-full flex justify-center mt-2"
                onClick={() => {
                  setDriversModal(!driversModal);
                }}
              >
                <div className="w-[60px] h-[2px] rounded-full bg-[#E2E2E2]" />
              </div>
              <div className="w-full flex justify-between p-3">
                <h4 className=" text-start">Οδηγοί</h4>
                <AddDriverDashboardModal plateno={carInfo.plateno} />
              </div>
              <div className="flex flex-col overflow-y-auto scrollbar p-3">
                {driversList.length > 0 ? (
                  driversList.map((driver, index) => (
                    <Driver driver={driver} key={index} />
                  ))
                ) : (
                  <div className="flex flex-col gap-1">
                    <p className="text-body">Δεν υπάρχουν καταχωρίσεις.</p>
                    <h6 className="text-[#6A6A6A]">
                      Πρόσθεσε οδηγούς για να εμφανιστούν στη λίστα.
                    </h6>
                  </div>
                )}
              </div>
            </DialogContent>
          </Dialog>
        </>
      )}
      {active && !cncode && hasOnlyDriversRole && (
        <div className="lg:absolute right-0 -top-5 lg:bg-white lg:bg-opacity-60 lg:backdrop-blur-[20.74875831604004px] flex flex-col gap-4 p-4 rounded-[10px] max-lg:w-full xl:w-[210px] 2xl:w-[288px] ">
          <h3 className="max-lg:hidden">Η παραγγελία ολοκληρώθηκε.</h3>
          <div className="flex flex-col xl:max-h-[65px] 2xl:max-h-[120px] overflow-y-auto scrollbar">
            <Button
              className={
                'text-secondary-button bg-white border border-[#A5A5A5] w-full py-3 rounded-[6px] flex gap-1.5 items-center justify-center'
              }
              onClick={() => {
                navigate('/service-booking');
              }}
            >
              <ToolIcon />
              Ραντεβού Service
            </Button>
          </div>
        </div>
      )}
      {active && cncode && (
        <div className="lg:absolute right-0 -top-5 lg:bg-white bg-opacity-60 backdrop-blur-[20.74875831604004px] flex flex-col gap-4 p-4 rounded-[10px] xl:w-[210px] 2xl:w-[288px] ">
          <h3 className='max-lg:hidden'>Η παραγγελία ολοκληρώθηκε.</h3>
          <div className="flex flex-col xl:max-h-[65px] 2xl:max-h-[120px]">
            <div className="flex flex-col gap-1 overflow-y-scroll scrollbar">
              <div className="flex items-center gap-2">
                <ClockIcon />
                <h5>Προς παράδοση</h5>
              </div>
              <h6 className="text-grenite text-disclaimer">
                {[7, 8].includes(step)
                  ? mapStepToMessage(step, substatus) || message
                  : mapStepToText(step)}
                {/* Θα ενημερωθείς μέσω email για τη διαδικασία παραλαβής. */}
              </h6>
            </div>
          </div>
        </div>
      )}
      {active && carInfo.plateno && (
        <div className="text-center py-6 max-lg:grid max-lg:grid-cols-2 lg:border-[#A5A5A5] lg:border-t lg:flex lg:w-[70vw] justify-between  lg:-mt-12 max-lg:gap-3">
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Κατασκευαστής/ Μοντέλο</p>
            <p className="text-body">
              {carInfo.MakeName} {carInfo.ModelName}
            </p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Αριθμός Πινακίδας</p>
            <p className="text-body">{carInfo.plateno}</p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Τύπος Καυσίμου</p>
            <p className="text-body">{carInfo.FuelType}</p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Τύπος Αυτοκινήτου</p>
            <p className="text-body">{carInfo.BodyType}</p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Πρώτη Άδεια Κυκλοφορίας</p>
            <p className="text-body">{carInfo.FirstLicenseDate.split('-')[2] + '/' +carInfo.FirstLicenseDate.split('-')[1] + '/' + carInfo.FirstLicenseDate.split('-')[0]}</p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Λήξη Συμβολαίου </p>
            <p className="text-body">{carInfo.EndDate.split('-')[2] + '/' +carInfo.EndDate.split('-')[1] + '/' + carInfo.EndDate.split('-')[0]}</p>
          </div>
        </div>
      )}
    </div>
  );
};
